The identifier for the `Candidate` that applied for the position opening.
